import { ToastrService } from 'ngx-toastr';
import { VW_ERROR_CODES } from 'vwappservices';

/**
 * Shows a success/error toast for a VwApiRequestsService-style response and returns whether
 * it succeeded, so callers can gate side effects (resetting a form, closing a panel, etc.)
 * on the call actually having worked instead of always running them.
 */
export function notifyResult(toastr: ToastrService, res: { errorCode: string; errorDescription?: string }, successMessage: string): boolean {
  if (res.errorCode === VW_ERROR_CODES.SUCCESS) {
    toastr.success(successMessage);
    return true;
  }
  toastr.error(res.errorDescription || 'Something went wrong. Please try again.');
  return false;
}

/**
 * Same failure handling as notifyResult (real backend error, not a hardcoded string) but for
 * read-only calls (list/load) where a toast on every successful fetch would be noise — this
 * only ever toasts on failure.
 */
export function reportApiError(toastr: ToastrService, res: { errorCode: string; errorDescription?: string }): boolean {
  if (res.errorCode === VW_ERROR_CODES.SUCCESS) return true;
  toastr.error(res.errorDescription || 'Something went wrong. Please try again.');
  return false;
}
